/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `GBP` - £
* `USD` - $
* `EUR` - €
 */
export type ContextMetricUnitEnum = typeof ContextMetricUnitEnum[keyof typeof ContextMetricUnitEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContextMetricUnitEnum = {
  GBP: 'GBP',
  USD: 'USD',
  EUR: 'EUR',
} as const;
